export function currencyFormatter(str: string) {
    if (!str) return;

    return str.includes('.') ? str.replace('.', ',') + (str.split('.')[1].length === 1 ? '0' : '') : str + ',00';
}
